import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';

import { CustomAlert, CustomButton, Text } from '../../../../../../shared/uiComponents';
import { PauseIcon } from '../../../../../../shared/Assets/svgIcons';
import { errorNormalizer } from '../../../../../../shared/Helpers/functions';
import { ButtonWrapper } from '../../../../../../components/StyledComponents';

import { DispatchProperties, useSelector } from '../../../../../../redux/store';
import { getTargets, holdTarget, openTarget } from '../../../../../../redux/State/clientSlice/programTargetSlice';
import { TargetProperties } from '../../../../../../redux/API/ClientAPIHelpers/programTargetsProperties';

const Hold = ({ target }: { target: TargetProperties }) => {
	const { id, programId, status } = target;
	const dispatch = useDispatch<DispatchProperties>();
	const includeMastered = useSelector((state) => state.programTarget.includeMastered);

	const [openHold, setOpenHold] = useState<boolean>(false);
	const [openUnHold, setOpenUnHold] = useState<boolean>(false);

	const holdTargetHandler = () => {
		if (!id || !programId) return;

		dispatch(holdTarget({ id, programId }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getTargets({ programId, includeMastered }));
				setOpenHold(false);
				toast('Successful');
			})
			.catch(errorNormalizer);
	};

	const unHoldTargetHandler = () => {
		if (!id || !programId) return;

		dispatch(openTarget({ id, programId }))
			.then(unwrapResult)
			.then(() => {
				dispatch(getTargets({ programId, includeMastered }));
				setOpenHold(false);
				toast('Successful');
			})
			.catch(errorNormalizer);
	};

	const handleOpen = () => {
		const value = status.id === 3;
		setOpenUnHold(value);
		setOpenHold(!value);
	};

	return (
		<>
			<div className="actionRow" onClick={handleOpen}>
				<div className="actionIcon">
					<PauseIcon />
				</div>
				<div className="actionContent">
					<Text title={status.id === 3 ? 'Unhold' : 'Put on Hold'} type="psm" fontWeight="medium" />
				</div>
			</div>
			<CustomAlert
				title="Do you want to put target on hold?"
				onClose={() => setOpenHold(false)}
				open={openHold}
				Content={() => (
					<ButtonWrapper>
						<CustomButton title="Hold target" onClick={holdTargetHandler} />
						<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpenHold(false)} />
					</ButtonWrapper>
				)}
			/>
			<CustomAlert
				title="Do you want to unhold target?"
				onClose={() => setOpenUnHold(false)}
				open={openUnHold}
				Content={() => (
					<ButtonWrapper>
						<CustomButton title="Unhold target" onClick={unHoldTargetHandler} />
						<CustomButton title="Cancel" buttonType="secondaryGray" onClick={() => setOpenUnHold(false)} />
					</ButtonWrapper>
				)}
			/>
		</>
	);
};

export default Hold;
